__turbopack_context__.v({
  "bubble-component": "bubble-button-component-module-scss-module__m7TGpq__bubble-component",
  "bubble-component--highlighted": "bubble-button-component-module-scss-module__m7TGpq__bubble-component--highlighted",
});
